module.exports = __webpack_public_path__ + "static/media/astreal_divider.59541c5b.jpg";